<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 企业变动分析
	export default {
		name: 'EnterpriseStabilityLineChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			title: {
				type: String,
				default: '企业变动分析'
			},

			// 数据
			chartData: {
				type: Array,
				default: () => []
			},
			// X轴数据（月份）
			xAxisData: {
				type: Array,
				default: () => []
			},
			// 线条颜色
			lineColor: {
				type: String,
				default: '#1890ff'
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line'
						}
					},
					grid: {
						left: '4%',
						right: '8%',
						bottom: '3%',
						top: '11%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: this.xAxisData,
						boundaryGap: false,
						axisLine: {
							lineStyle: {
								color: '#E0E0E0'
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#E0E0E0',
								type: 'solid'
							}
						},
						// 添加X轴名称
						name: '月份',
						nameLocation: 'end',
						nameGap: 13,
						nameTextStyle: {
							fontSize: 14,
							color: '#666'
						}
					},
					yAxis: {
						type: 'value',
						minInterval: 1,
						min: 0,
						max: 30,
						axisLine: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							color: '#666',
							fontSize: 14
						},
						splitLine: {
							lineStyle: {
								color: '#E0E0E0',
								type: 'solid'
							}
						},
						// 添加Y轴名称
						name: '变动次数',
						nameLocation: 'end',
						nameGap: 13,
						nameTextStyle: {
							fontSize: 14
						}
					},
					series: [
						{
							type: 'line',
							data: this.chartData,
							smooth: false,
							symbol: 'circle',
							symbolSize: 6,
							itemStyle: {
								color: this.lineColor
							},
							lineStyle: {
								width: 2,
								color: this.lineColor
							}
						}
					]
				}
			}
		},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
